<template>
  <v-row>
    <v-col cols="12" md="12">
      <div v-if="local_personality_test_src" class="d-flex flex-column align-start">
        <v-img :src="local_personality_test_src" aspect-ratio="1" :width="300" :height="300" :eager="true"
          class="mb-2 cursor-pointer elevation-2" @click="dialog = true"></v-img>

        <!-- <v-btn tag="a" small color="primary" :href="local_personality_test_src" target="_blank" download class="mb-4">
          <v-icon left>mdi-download</v-icon>
          Download Image
        </v-btn> -->

        <v-dialog v-model="dialog" max-width="90vh">
          <v-card>
            <v-card-text class="pa-0 relative">
              <v-btn icon dark absolute top right @click="dialog = false" class="mt-2 mr-2"
                style="z-index: 1; background-color: rgba(0,0,0,0.3);">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-img :src="local_personality_test_src" contain max-height="90vh"></v-img>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" :href="local_personality_test_src" target="_blank" download>
                <v-icon left>mdi-download</v-icon>
                Download
              </v-btn>
              <v-btn text @click="dialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-col>
    <v-col cols="12" md="12">
      <v-file-input accept="image/*" placeholder="Select your personality test image" prepend-icon="mdi-camera"
        ref="image" label="Personality test" dense v-model="selected_file"
        @change="updatePersonalityTestImage"></v-file-input>
    </v-col>
  </v-row>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "PersonalityTest",
  props: ['personal_information', 'personality_test_src'],
  data() {
    return {
      img_base_url: process.env.VUE_APP_IMG_BASE_URL,
      local_personality_test_src: this.personality_test_src,
      selected_file: null,
      dialog: false
    }
  },
  watch: {
    personality_test_src(newVal) {
      this.local_personality_test_src = newVal;
    }
  },
  mounted() {
    console.log(this.img_base_url)
    console.log(process.env.VUE_APP_IMG_BASE_URL)
  },
  methods: {
    async updatePersonalityTestImage() {
      try {
        if (!this.selected_file)
          return false
        else {
          await this.removePersonalityTest();
          let formData = new FormData()
          await formData.append('profile', this.selected_file)

          const upload_result = await this.$http.post('/back-office/supporters/profile-image', formData, authHeader())
          if (upload_result) {
            this.personal_information.personality_test_url = upload_result.data.file_name
            this.local_personality_test_src = `${this.img_base_url}/uploads/supporters/${this.personal_information.personality_test_url}`
            this.selected_file = null
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async removePersonalityTest() {
      try {
        if (!this.personal_information.personality_test_url)
          return;
        else {
          let fileName = this.personal_information.personality_test_url.split('/').pop()
          await this.$http.delete(`/back-office/supporters/profile-image/${fileName}`, authHeader())
          this.personal_information.personality_test_url = null
          return;
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.relative {
  position: relative;
}
</style>
